import { Content, Header } from '@mainstage/core-components';
import { Box, useTheme } from '@material-ui/core';
import { CustomMicrofrontendComponent } from './CustomMicrofrontendComponent';
import { CustomMicrofrontendOptions } from './CustomMicrofrontendConfiguration';
import { WbPage } from '@agilelab/plugin-wb-platform';

export const CustomMicrofrontendPage = (props: CustomMicrofrontendOptions) => {
  const theme = useTheme();
  return (
    <WbPage themeId="home">
      <Header title={props.title} />
      <Content>
        <Box
          display="flex"
          flexDirection="column"
          style={{ gap: theme.spacing(2) }}
        >
          <CustomMicrofrontendComponent key={props.identifier} {...props} />
        </Box>
      </Content>
    </WbPage>
  );
};
